import { Route, Routes } from "@angular/router";

import { companiesManagementRoutes } from "../users-management/nested-features/companies";

import { ReservationTicket, TourServicesCodes } from "src/app/core";

export const schoolUniversityVisitsRoute: Route = {
  path: "school-university-requests",
  title: "REQUESTS.SCHOOL_UNIVERSITY_REQUESTS",
  data: { reservationTicketType: ReservationTicket.organizedSchool },
  loadComponent: () => import("./pages/reservation-requests/reservation-requests.component").then((c) => c.ReservationRequestsComponent),
};

export const membershipRequestsRoute: Route = {
  path: "membership-requests",
  title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP_REQUESTS",
  loadComponent: () => import("./pages/membership-requests/membership-requests.component").then((c) => c.MembershipRequestsComponent),
};

export const officialInstitutionsRoute: Route = {
  path: "official-institutions",
  title: "OFFICIAL_INSTITUTIONS.TITLE",
  data: { reservationTicketType: ReservationTicket.officialInstitutions },
  loadComponent: () => import("./pages/reservation-requests/reservation-requests.component").then((c) => c.ReservationRequestsComponent),
};

export const tourismCompaniesRoute: Route = {
  path: "tourism-companies",
  title: "SERVICES.TourismCompanies",
  loadComponent: () =>
    import("./pages/tourism-companies-requests/tourism-companies-requests.component").then((c) => c.TourismCompaniesRequestsComponent),
};

export const guidedToursRoute: Route = {
  path: "guided-tours",
  title: "SERVICES.GuidedTours",
  data: { reservationTicketType: ReservationTicket.guidedTours },
  loadComponent: () => import("./pages/reservation-requests/reservation-requests.component").then((c) => c.ReservationRequestsComponent),
};

export const requestsManagementRoutes: Routes = [
  {
    path: "",
    title: "REQUESTS.MANAGEMENT",
    data: {
      tabs: [
        {
          key: TourServicesCodes.OfficialInstitutions,
          title: "OFFICIAL_INSTITUTIONS.TITLE",
          routerLink: "official-institutions",
        },
        {
          key: TourServicesCodes.TourismCompanies,
          title: "SERVICES.TourismCompanies",
          routerLink: "tourism-companies",
        },
        {
          key: TourServicesCodes.GuidedTours,
          title: "SERVICES.GuidedTours",
          routerLink: "guided-tours",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        path: "",
        redirectTo: officialInstitutionsRoute.path,
        pathMatch: "full",
      },
      officialInstitutionsRoute,
      tourismCompaniesRoute,
      guidedToursRoute,
    ],
  },
  {
    path: tourismCompaniesRoute.path,
    children: companiesManagementRoutes,
  },
];
